<bit-dialog
  class="bv-account-dialog bv-account-edit-email-dialog"
  [title]="'editEmail' | i18n"
  dialogSize="default"
>
  <ng-container bitDialogContent>
    <app-change-email #changeEmail></app-change-email>
  </ng-container>
  <ng-container bitDialogFooter>
    <div class="bv-account-dialog__footer">
      <div class="bv-account-dialog__footer-start">
        <button
          type="button"
          class="bv-account-dialog__icon-btn"
          [attr.aria-label]="'clear' | i18n"
          (click)="clearEmail()"
        >
          <span class="bv-account-dialog__icon-btn__trash" aria-hidden="true"></span>
        </button>
      </div>
      <div class="bv-account-dialog__footer-end">
        <button
          bitButton
          bitFormButton
          type="button"
          buttonType="secondary"
          class="bv-account-dialog__cancel-btn"
          bitDialogClose
        >
          {{ "cancel" | i18n }}
        </button>
        <button
          bitButton
          bitFormButton
          type="button"
          buttonType="primary"
          class="bv-account-dialog__save-btn"
          (click)="submitEmail()"
        >
          {{ submitLabel() | i18n }}
        </button>
      </div>
    </div>
  </ng-container>
</bit-dialog>
